module.exports = __webpack_public_path__ + "static/media/1713.bd564f45.png";